module.exports = __webpack_public_path__ + "img/203.22f534c8.jpg";